var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromiseToSell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.822,
    height: 100.998,
    viewBox: "0 0 116.822 100.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10766",
    "data-name": "Group 10766",
    transform: "translate(-1090.868 -1194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10709",
    "data-name": "Group 10709",
    transform: "translate(79.824 75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10707",
    "data-name": "Group 10707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_52",
    "data-name": "Subtraction 52",
    d: "M87.421,101H35.435a3.154,3.154,0,0,1-3.128-3.16v-3.37H28.973a3.154,3.154,0,0,1-3.127-3.16V68.739L4.743,47.412,3.527,48.64a1.753,1.753,0,0,0,0,2.458l9.119,9.275a1.534,1.534,0,0,1-.588,2.713,1.5,1.5,0,0,1-1.531-.573L1.387,53.26a4.831,4.831,0,0,1,0-6.778L2.6,45.254l-1.22-1.233a4.828,4.828,0,0,1,.087-6.69,4.707,4.707,0,0,1,6.62-.08L25.845,55.187V6.422a3.153,3.153,0,0,1,3.132-3.16H39.024a4.726,4.726,0,0,1,8.987,0H93.6a3.154,3.154,0,0,1,3.127,3.16v3.37h3.322a3.155,3.155,0,0,1,3.122,3.16V85.074a4.819,4.819,0,0,1-1.39,3.387L90.762,99.593A4.716,4.716,0,0,1,87.421,101Zm-53.6-19.46a1.505,1.505,0,0,1,.779.218,1.531,1.531,0,0,1,.732,1.391V97.838a.1.1,0,0,0,.03.076.1.1,0,0,0,.073.031h51.8v-9.9a3.153,3.153,0,0,1,3.128-3.16h9.8V12.952a.1.1,0,0,0-.1-.107H56.44a1.529,1.529,0,0,1,0-3.053H93.7V6.422a.106.106,0,0,0-.1-.1H48.262V9.792h1.72l.08,0a1.52,1.52,0,0,1,1.3.741,1.541,1.541,0,0,1,0,1.575,1.519,1.519,0,0,1-1.3.741l-.08,0h-1.72v5.006a4.742,4.742,0,1,1-9.483,0,1.512,1.512,0,0,1,3.021,0,1.719,1.719,0,0,0,3.436,0V12.845h-9.8a.107.107,0,0,0-.106.107V64.77l7.038,7.112a4.818,4.818,0,0,1,.86,5.523l1.39,1.4a1.543,1.543,0,0,1,.567,1.547,1.522,1.522,0,0,1-1.155,1.166,1.5,1.5,0,0,1-1.531-.572l-1.39-1.4a4.7,4.7,0,0,1-5.462-.9L28.871,71.8V91.309a.106.106,0,0,0,.106.106h3.334V83.147a1.531,1.531,0,0,1,.731-1.391A1.51,1.51,0,0,1,33.822,81.538Zm56.535,6.4h0a.1.1,0,0,0-.1.107v7.737l7.767-7.844H90.357ZM39.041,72.8l-2.433,2.458,1.22,1.233a1.684,1.684,0,0,0,2.424,0l.009-.013a1.726,1.726,0,0,0,0-2.445Zm-9.166-9.223-2.433,2.458,7.017,7.073,2.4-2.457ZM9.319,42.817h0L6.879,45.254,25.312,63.892l2.432-2.458L9.319,42.818Zm19.658-36.5a.107.107,0,0,0-.106.107V58.232l3.441,3.485V12.947a3.153,3.153,0,0,1,3.127-3.16h9.8V6.315ZM4.8,38.942a1.7,1.7,0,0,0-1.218.509,1.752,1.752,0,0,0-.055,2.4l1.216,1.233,2.433-2.458-1.22-1.233A1.708,1.708,0,0,0,4.8,38.942ZM48.363,92.849a4.682,4.682,0,0,1-1.5-.247,4.781,4.781,0,0,1-3.242-4.552V86.418a1.528,1.528,0,0,1,.732-1.39,1.5,1.5,0,0,1,1.559,0,1.527,1.527,0,0,1,.731,1.39V88.05A1.738,1.738,0,0,0,47.818,89.7a1.7,1.7,0,0,0,.544.089,1.724,1.724,0,0,0,1.374-.691l8.726-11.754a1.507,1.507,0,0,1,2.69.617L62.1,82.77l2.818-3.8a1.506,1.506,0,0,1,2.644.428l.878,2.663a1.692,1.692,0,0,0,1.615,1.191h5.767l0,0,.08,0a1.517,1.517,0,0,1,1.3.741,1.541,1.541,0,0,1,0,1.575,1.515,1.515,0,0,1-1.3.741l-.082,0H70.073a4.749,4.749,0,0,1-4.459-3.177l-3.115,4.2a1.507,1.507,0,0,1-2.69-.617l-.954-4.812-6.7,9.022A4.746,4.746,0,0,1,48.363,92.849ZM46.19,71.613a1.038,1.038,0,0,1-.886-.742,2.164,2.164,0,0,1,0-1.574,1.038,1.038,0,0,1,.886-.741l.055,0H74.954l.054,0a1.04,1.04,0,0,1,.886.741,2.164,2.164,0,0,1,0,1.574,1.038,1.038,0,0,1-.886.742c-.018,0-.036,0-.055,0H46.245Zm0-8.16a1.039,1.039,0,0,1-.887-.741,2.176,2.176,0,0,1,0-1.575,1.039,1.039,0,0,1,.887-.741l.055,0h28.71l.055,0a1.039,1.039,0,0,1,.887.741,2.167,2.167,0,0,1,0,1.575,1.038,1.038,0,0,1-.886.741c-.018,0-.036,0-.055,0H46.245Zm0-8.162a1.04,1.04,0,0,1-.886-.741,2.173,2.173,0,0,1,0-1.574,1.039,1.039,0,0,1,.885-.742l.054,0H74.905c.549.043.978.714.978,1.526s-.43,1.484-.978,1.526H46.243C46.225,55.291,46.207,55.291,46.189,55.291ZM83.479,45.5l-.177,0H48.41c-1.735-.042-3.094-.713-3.094-1.526s1.359-1.483,3.094-1.526H83.3l.172,0a4.856,4.856,0,0,1,2.8.741.9.9,0,0,1,0,1.575A4.838,4.838,0,0,1,83.479,45.5ZM48.409,37.334a4.818,4.818,0,0,1-2.789-.741.9.9,0,0,1,0-1.575,4.8,4.8,0,0,1,2.784-.741l.176,0H83.317l.176,0a4.805,4.805,0,0,1,2.785.741.9.9,0,0,1,0,1.575,4.821,4.821,0,0,1-2.789.741c-.057,0-.114,0-.172,0H48.58ZM85.23,29.174c-.026,0-.053,0-.08,0H73.84a1.53,1.53,0,0,1,0-3.053H85.15l.08,0a1.517,1.517,0,0,1,1.3.741,1.536,1.536,0,0,1,0,1.575A1.514,1.514,0,0,1,85.23,29.174Z",
    transform: "translate(1011.045 1119)",
    fill: "#00641f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10708",
    "data-name": "Group 10708",
    transform: "translate(-26.016 -2.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_137",
    "data-name": "Ellipse 137",
    transform: "translate(1091.222 1160)",
    fill: "#fff",
    stroke: "#00641f",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.33,
    cy: 31.33,
    rx: 31.33,
    ry: 31.33,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.33,
    cy: 31.33,
    rx: 30.58,
    ry: 30.58,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Promise_-_Flaticon-3",
    "data-name": "Search results for Promise - Flaticon-3",
    transform: "translate(1096.781 1174.851)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_408428168",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10706",
    "data-name": "Group 10706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10704",
    "data-name": "Group 10704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_408423584",
    transform: "translate(9.942 5.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10326",
    "data-name": "Path 10326",
    d: "M105.449,260.519a2.919,2.919,0,0,1-.9-.2,4.989,4.989,0,0,1-2-2.5,2.058,2.058,0,0,1-1.7-.4,2.662,2.662,0,0,1-1.2-1.8,2.412,2.412,0,0,1-3.2-2.2,2.126,2.126,0,0,1-2.4-.9,2.65,2.65,0,0,1,.3-3c1.3-1.1,2.6-2.2,3.9-3.4,2.4-2.1,5-4.3,7.5-6.5a.519.519,0,0,1,.4-.2l1.4-.1c1.6-.2,3.4,1.5,4.7,2.7l.3.3a1.214,1.214,0,0,0,1.5.1c.5-.4.4-1.2-.2-2.1a5.581,5.581,0,0,1-.5-.8,14.025,14.025,0,0,0-1.2-1.8c-.8-1-3.6-2.1-4.6-2.4a4.813,4.813,0,0,0-4,.1l-5.5,3.3a.6.6,0,0,1-.4.1l-2.3.2a.751.751,0,1,1-.1-1.5l2.1-.2,5.4-3.2a6.958,6.958,0,0,1,5.3-.3c.4.2,4,1.4,5.3,2.9a13.727,13.727,0,0,1,1.3,2,5.58,5.58,0,0,0,.5.8c1.2,1.9.7,3.3-.1,4a2.722,2.722,0,0,1-3.5-.1l-.3-.3c-.9-.8-2.7-2.4-3.6-2.3l-1.1.1c-2.5,2.1-4.9,4.3-7.3,6.4l-3.9,3.3a1.394,1.394,0,0,0,0,1.1c.2.3.8.3,1.6,0a.878.878,0,0,1,.7.1,1.08,1.08,0,0,1,.3.7c-.1.3-.1,1.2.4,1.5a2.006,2.006,0,0,0,1.7,0,.471.471,0,0,1,.6.1.675.675,0,0,1,.4.6c0,.3.1,1.2.6,1.5.3.2.7.1,1.3-.1a.661.661,0,0,1,.6.1.675.675,0,0,1,.4.6,2.843,2.843,0,0,0,1.2,2.1.592.592,0,0,0,.7-.1l2.5-1.6.4-.3a.668.668,0,0,1,1,.1.783.783,0,0,1-.1,1.1l-.4.3-2.5,1.7A2.009,2.009,0,0,1,105.449,260.519Zm15.59-10.993a.712.712,0,0,1-.6-.3.783.783,0,0,1,.1-1.1l3.8-2.7a.668.668,0,0,1,1,.1.791.791,0,0,1-.1,1.1l-3.8,2.7A.758.758,0,0,1,121.04,249.526Z",
    transform: "translate(-93.729 -233.484)",
    fill: "#00641f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_408426368",
    transform: "translate(6.56 19.352)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10327",
    "data-name": "Path 10327",
    d: "M69.673,378.674a.367.367,0,0,1-.3-.1l-3.3-1.5a.819.819,0,0,1-.4-1,.862.862,0,0,1,1-.4l3.4,1.6a.777.777,0,0,1,.3,1A.669.669,0,0,1,69.673,378.674Z",
    transform: "translate(-65.639 -375.639)",
    fill: "#00641f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_408420872",
    transform: "translate(23.308 4.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10328",
    "data-name": "Path 10328",
    d: "M236.763,234.141a4.612,4.612,0,0,1-3.4-1.1,9.056,9.056,0,0,0-3.1-1.4,4.222,4.222,0,0,0-2.8.3.71.71,0,1,1-1.1-.9c.9-1.2,3.3-1.1,4.3-.8a9.4,9.4,0,0,1,3.6,1.6c.8.6,1.3.9,4.1.7a.64.64,0,0,1,.8.6c.1.5-.2.8-.7.9C237.863,234.041,237.263,234.141,236.763,234.141Z",
    transform: "translate(-226.189 -230.049)",
    fill: "#00641f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_408421184",
    transform: "translate(32 16.964)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10329",
    "data-name": "Path 10329",
    d: "M316.568,359.866h-.4a2.7,2.7,0,0,1-1.7-1,.783.783,0,0,1,.1-1.1.8.8,0,0,1,1.1.2c.1.2.4.3.7.4a1.077,1.077,0,0,0,.8-.2,1.012,1.012,0,0,0,.4-.7.777.777,0,0,0-.2-.8l-2.2-3a1.012,1.012,0,0,0-.7-.4.777.777,0,0,0-.8.2,1.011,1.011,0,0,0-.4.7.777.777,0,0,0,.2.8.814.814,0,0,1-.2,1.1.775.775,0,0,1-1-.2,2.505,2.505,0,0,1-.5-1.9,2.332,2.332,0,0,1,1-1.7,2.5,2.5,0,0,1,1.9-.5,2.7,2.7,0,0,1,1.7,1l2.2,3a2.505,2.505,0,0,1,.5,1.9,2.332,2.332,0,0,1-1,1.7A2.974,2.974,0,0,1,316.568,359.866Z",
    transform: "translate(-311.745 -351.745)",
    fill: "#00641f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_408425096",
    transform: "translate(28.174 18.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10330",
    "data-name": "Path 10330",
    d: "M280.576,373.194a2.657,2.657,0,0,1-2.1-1l-3.8-5a2.558,2.558,0,0,1,.6-3.6,2.2,2.2,0,0,1,1.5-.6,2.607,2.607,0,0,1,2.1,1.1l3.7,5a2.472,2.472,0,0,1-.5,3.6A2.1,2.1,0,0,1,280.576,373.194Zm-3.8-8.595a.734.734,0,0,0-.6.2,1,1,0,0,0-.2,1.5l3.7,5a.974.974,0,0,0,.9.4,1.421,1.421,0,0,0,.6-.2,1,1,0,0,0,.2-1.5l-3.7-5A.974.974,0,0,0,276.778,364.6Z",
    transform: "translate(-274.2 -363)",
    fill: "#00641f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_408426968",
    transform: "translate(25.537 20.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10331",
    "data-name": "Path 10331",
    d: "M254.372,399.674a.756.756,0,0,1-.4-.1,2.332,2.332,0,0,1-1.7-1,.684.684,0,0,1,.2-1,.668.668,0,0,1,1,.1.866.866,0,0,0,.7.4,1.019,1.019,0,0,0,.9-.2,1.192,1.192,0,0,0,.2-1.5.668.668,0,0,1,.1-1,.783.783,0,0,1,1.1.1,2.775,2.775,0,0,1-.5,3.7A3.021,3.021,0,0,1,254.372,399.674Zm-4.6-5a.907.907,0,0,1-.7-.3,2.813,2.813,0,0,1-.4-2,2.532,2.532,0,0,1,1-1.7,2.573,2.573,0,0,1,3.6.6.668.668,0,0,1-.1,1,.783.783,0,0,1-1.1-.1,1.12,1.12,0,0,0-1.5-.3,1.234,1.234,0,0,0-.4.8.881.881,0,0,0,.2.8.775.775,0,0,1-.2,1A.758.758,0,0,1,249.775,394.677Z",
    transform: "translate(-248.639 -390.2)",
    fill: "#00641f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_408421784",
    transform: "translate(22.465 22.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10332",
    "data-name": "Path 10332",
    d: "M224.367,421.294a2.607,2.607,0,0,1-2.1-1.1l-3-4.1a2.505,2.505,0,0,1-.5-1.9,2.7,2.7,0,0,1,1-1.7,3.021,3.021,0,0,1,1.6-.5,2.46,2.46,0,0,1,2,1l3.1,4.1a2.775,2.775,0,0,1-.5,3.7A3.021,3.021,0,0,1,224.367,421.294Zm-3-7.8a1.445,1.445,0,0,0-.7.2,1.012,1.012,0,0,0-.4.7.777.777,0,0,0,.2.8l3,4.1a1.192,1.192,0,0,0,.9.5,1.852,1.852,0,0,0,.7-.2,1.358,1.358,0,0,0,.2-1.6l-3.1-4.1A1.233,1.233,0,0,0,221.369,413.5Z",
    transform: "translate(-218.745 -412)",
    fill: "#00641f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_408425408",
    transform: "translate(12.378 19.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10333",
    "data-name": "Path 10333",
    d: "M121.475,385.772a.763.763,0,0,1-.5-.2.784.784,0,0,1,0-1.1l3.5-3.5a.666.666,0,0,1,1,0,.784.784,0,0,1,0,1.1l-3.4,3.4A.864.864,0,0,1,121.475,385.772Z",
    transform: "translate(-120.75 -380.75)",
    fill: "#00641f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_408420656",
    transform: "translate(15.55 22.861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10334",
    "data-name": "Path 10334",
    d: "M152.475,414.972c-.2,0-.4,0-.5-.2a.666.666,0,0,1,0-1l2.8-2.8a.668.668,0,0,1,1,0,.784.784,0,0,1,0,1.1l-2.8,2.7C152.874,414.972,152.674,414.972,152.475,414.972Z",
    transform: "translate(-151.75 -410.75)",
    fill: "#00641f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_408426272",
    transform: "translate(18.511 26.159)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10335",
    "data-name": "Path 10335",
    d: "M181.475,446.873a.764.764,0,0,1-.5-.2.784.784,0,0,1,0-1.1l1.6-1.6a.777.777,0,1,1,1.1,1.1l-1.6,1.6A1.421,1.421,0,0,1,181.475,446.873Z",
    transform: "translate(-180.75 -443.75)",
    fill: "#00641f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_408424472",
    transform: "translate(35.04)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10336",
    "data-name": "Path 10336",
    d: "M348.059,201.488a4.538,4.538,0,0,1-3.9-2.3l-4.8-8.395a4.465,4.465,0,0,1,1.7-6.2l3.4-2a4.643,4.643,0,0,1,2.3-.6,4.538,4.538,0,0,1,3.9,2.3l4.8,8.295a4.692,4.692,0,0,1-1.7,6.3l-3.4,1.9A4.753,4.753,0,0,1,348.059,201.488Zm-1.3-17.989a2.408,2.408,0,0,0-1.5.4l-3.5,2a2.971,2.971,0,0,0-1.1,4.1l4.8,8.395a2.793,2.793,0,0,0,2.6,1.5,2.6,2.6,0,0,0,1.5-.4l3.5-1.9a3.181,3.181,0,0,0,1.1-4.2l-4.8-8.395A3.109,3.109,0,0,0,346.76,183.5Z",
    transform: "translate(-338.739 -182)",
    fill: "#00641f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_408424136",
    transform: "translate(0 4.697)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10337",
    "data-name": "Path 10337",
    d: "M4.894,247.689a1.485,1.485,0,0,1-.9-.2l-2.1-.7a2.74,2.74,0,0,1-1.7-3.6l4.4-12.292a2.789,2.789,0,0,1,2.7-1.9,1.485,1.485,0,0,1,.9.2l2.1.7a2.819,2.819,0,0,1,1.7,3.6l-4.4,12.292A2.925,2.925,0,0,1,4.894,247.689Zm2.4-17.19a1.423,1.423,0,0,0-1.3.9L1.6,243.691a1.3,1.3,0,0,0,.8,1.7l2.1.7a.6.6,0,0,0,.4.1,1.423,1.423,0,0,0,1.3-.9L10.59,233a1.379,1.379,0,0,0-.8-1.7l-2.1-.7A.6.6,0,0,0,7.292,230.5Z",
    transform: "translate(0.004 -229)",
    fill: "#00641f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_408420944",
    transform: "translate(42.924 10.194)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10338",
    "data-name": "Path 10338",
    d: "M420.161,289.1a2.483,2.483,0,0,1-2.2-1.3,2.964,2.964,0,0,1-.3-1.9,2.554,2.554,0,0,1,1.2-1.5,2.009,2.009,0,0,1,1.3-.4,2.6,2.6,0,0,1,2.2,1.3,3.192,3.192,0,0,1,.3,1.9,2.759,2.759,0,0,1-1.2,1.6A3.077,3.077,0,0,1,420.161,289.1Zm0-3.6a.764.764,0,0,0-.5.2c-.3.1-.4.3-.5.6a1.128,1.128,0,0,0,.1.8,1.049,1.049,0,0,0,.9.5.749.749,0,0,0,.5-.1,1.157,1.157,0,0,0,.5-.7.878.878,0,0,0-.1-.7A.96.96,0,0,0,420.161,285.5Z",
    transform: "translate(-417.625 -284)",
    fill: "#00641f"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromiseToSell);
export default __webpack_public_path__ + "static/media/promiseToSell.fa090b9ecdfd1945e0a31005f6925923.svg";
export { ForwardRef as ReactComponent };